import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../../../../../css/web/bedloop1/multiunit.css";

// Desplegable d'hostes amb una o més habitacions, cadascuna amb els seus
// adults/nens (només amb multiunit). Per sota s'envia el total d'adults i
// nens de sempre, més "distribucion" ("2-1;3-0") amb el detall per habitació.
// Els estils (.bh-habitacion*, .bh-anadir-habitacion, .formpersonas--horizontal)
// són a bedloophotel/global.css, que es carrega a totes les plantilles.
const PanelHabitaciones = ({
    show, setShow, toggleBlur, handleShow, formRef, etiquetaRef, onEtiqueta,
    capacidadMaxima, noninos, nobebes, adultosInicial, ninosInicial, bebesInicial, distribucionInicial,
}) => {

    const { t } = useTranslation();

    const [habitaciones, setHabitaciones] = useState(
        Array.isArray(distribucionInicial) && distribucionInicial.length > 0
            ? distribucionInicial
            : [{ adultos: parseInt(adultosInicial) || 1, ninos: parseInt(ninosInicial) || 0 }]
    );
    const [bebes, setBebes] = useState(parseInt(bebesInicial) || 0);

    const countAdults = habitaciones.reduce((total, hab) => total + hab.adultos, 0);
    const countNinos = habitaciones.reduce((total, hab) => total + hab.ninos, 0);

    const cambiarHabitacion = (index, campo, delta) => {
        setHabitaciones(prev => prev.map((hab, i) => {
            if (i !== index) return hab;
            const nuevoValor = hab[campo] + delta;
            if (campo === 'adultos' && nuevoValor < 1) return hab;
            if (campo === 'ninos' && nuevoValor < 0) return hab;
            const otroValor = campo === 'adultos' ? hab.ninos : hab.adultos;
            if (nuevoValor + otroValor > capacidadMaxima) return hab;
            return { ...hab, [campo]: nuevoValor };
        }));
    };

    const anadirHabitacion = () => setHabitaciones(prev => [...prev, { adultos: 1, ninos: 0 }]);
    const eliminarHabitacion = (index) => setHabitaciones(prev => prev.length > 1 ? prev.filter((_, i) => i !== index) : prev);

    // Etiqueta del desplegable tancat, recalculada sola a cada canvi. Amb
    // diverses habitacions el nombre va primer (el camp és estret i la resta
    // es talla amb "…", el detall complet és al desplegable i al title).
    useEffect(() => {
        let frase = t("Escoja personas");
        if (countAdults == 1) frase = " " + countAdults + " " + t("Adulto");
        if (countAdults > 1) frase = " " + countAdults + " " + t("Adultos");
        if (countNinos == 1) frase += " " + countNinos + " " + t("Niño");
        if (countNinos > 1) frase += " " + countNinos + " " + t("Niños");
        if (bebes == 1) frase += " " + bebes + " " + t("Bebé");
        if (bebes > 1) frase += " " + bebes + " " + t("Bebés");
        if (habitaciones.length > 1) frase = habitaciones.length + " " + t("Habitaciones") + " ·" + frase;
        frase = frase.trim();

        if (etiquetaRef && etiquetaRef.current) {
            etiquetaRef.current.textContent = frase;
            etiquetaRef.current.title = frase;
            etiquetaRef.current.classList.add('bh-numpersonas-multi');
        }
        if (onEtiqueta) onEtiqueta(frase);
    }, [countAdults, countNinos, bebes, habitaciones.length]);

    const boton = (onClick, mas) => (
        <button type="button" className="btn btn-xs btn-number boto-cercle" onClick={onClick}>
            <span className="centrar-boto-cercle">
                <svg viewBox="0 0 24 24" role="img" aria-label={mas ? "add" : "subtract"} focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}>
                    <rect height="2" rx="1" width="12" x="6" y="11"></rect>
                    {mas && <rect height="12" rx="1" width="2" x="11" y="6"></rect>}
                </svg>
            </span>
        </button>
    );

    const horizontal = habitaciones.length > 3;

    return (
        <div
            className={"formpersonas" + (horizontal ? " formpersonas--horizontal" : "")}
            style={{ display: show }}
            onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) { setShow("none"); toggleBlur(false); } }}
            tabIndex="0"
            onMouseLeave={handleShow}
            ref={formRef}
        >
            <div className={"bh-habitaciones" + (horizontal ? " bh-habitaciones--horizontal" : "")}>
                {habitaciones.map((habitacion, index) => (
                    <div className="bh-habitacion" key={index}>
                        {habitaciones.length > 1 && (
                            <div className="bh-habitacion__header">
                                <span className="bh-habitacion__titol">{t("Habitación")} {index + 1}</span>
                                <button type="button" className="bh-habitacion__eliminar" onClick={() => eliminarHabitacion(index)}>
                                    {t("Eliminar habitación")}
                                </button>
                            </div>
                        )}

                        <div className="mt-2 row">
                            <label className="col-md-6 col-6 etiqueta-formulari">
                                {t("Adultos")}
                                <div className="mini-etiqueta-formulari">({t("Desde_12_años")})</div>
                            </label>
                            <div className="col-md-4 col-6">
                                <div className="mt-4 input-group">
                                    <span className="input-group-btn">{boton(() => cambiarHabitacion(index, 'adultos', -1), false)}</span>
                                    <input type="text" className="form-control input-number numero-persones" value={habitacion.adultos} readOnly={true} />
                                    <span className="input-group-btn">{boton(() => cambiarHabitacion(index, 'adultos', 1), true)}</span>
                                </div>
                            </div>
                        </div>

                        {noninos == 0 && (
                            <>
                                <div className="linia"></div>
                                <div className="mt-3 row">
                                    <label className="col-md-6 col-6 etiqueta-formulari"> {t("Niños")}<div className="mini-etiqueta-formulari">({t("De_2_a_12_años")})</div></label>
                                    <div className="mt-2 col-md-4 col-6">
                                        <div className="mt-3 input-group">
                                            <span className="input-group-btn">{boton(() => cambiarHabitacion(index, 'ninos', -1), false)}</span>
                                            <input type="text" className="form-control input-number numero-persones" value={habitacion.ninos} readOnly={true} />
                                            <span className="input-group-btn">{boton(() => cambiarHabitacion(index, 'ninos', 1), true)}</span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>

            {nobebes == 0 && (
                <>
                    <div className="linia"></div>
                    <div className="mt-3 row">
                        <label className="col-md-6 col-6 etiqueta-formulari"> {t("Bebés")}<div className="mini-etiqueta-formulari">({t("De_0_a_2_años")})</div></label>
                        <div className="mt-2 col-md-4 col-6">
                            <div className="mt-3 input-group">
                                <span className="input-group-btn">{boton(() => setBebes(b => Math.max(0, b - 1)), false)}</span>
                                <input type="text" className="form-control input-number numero-persones" value={bebes} readOnly={true} />
                                <span className="input-group-btn">{boton(() => setBebes(b => Math.min(capacidadMaxima, b + 1)), true)}</span>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <input type="hidden" name="adultos" value={countAdults} />
            <input type="hidden" name="ninos" value={countNinos} />
            <input type="hidden" name="bebes" value={bebes} />
            <input type="hidden" name="distribucion" value={habitaciones.map(h => h.adultos + "-" + h.ninos).join(";")} />

            <div className="linia"></div>

            <button type="button" className="bh-anadir-habitacion" onClick={anadirHabitacion}>
                <i className="fa-solid fa-plus"></i> {t("Añadir habitación")}
            </button>
        </div>
    );
};

export default PanelHabitaciones;
